module.exports = __webpack_public_path__ + "img/cibus.286bdc98.png";